import { Footer } from "../Footer";

/* 與官網首頁共用完整頁腳，採用香港繁體文案及香港站導航。 */
export function HongKongFooter() {
  return <Footer lang="zh" locale="zh-HK" />;
}
